import {
  Compass,
  ScanSearch,
  TrendingUp,
  Presentation,
  AudioLines,
  PenLine,
  ShieldCheck,
  Gauge,
  RadioTower,
} from "lucide-react";

export const APPS = [
  {
    id: "browser-cognitivo",
    index: "01",
    name: "Browser Cognitivo Rexxpons",
    category: "Cognitive AI",
    description:
      "Navigazione web intelligente e context-aware, potenziata dall'AI per anticipare le esigenze di ricerca e analisi.",
    url: "https://www.nexxaris.com",
    domain: "nexxaris.com",
    Icon: Compass,
    span: "lg:col-span-2",
  },
  {
    id: "motore-ricerca",
    index: "02",
    name: "Motore di Ricerca Cognitivo",
    category: "Cognitive AI",
    description:
      "Motore di ricerca semantico avanzato che interpreta il significato profondo dei dati, oltre le semplici parole chiave.",
    url: "https://www.rexxengine.store",
    domain: "rexxengine.store",
    Icon: ScanSearch,
    span: "",
  },
  {
    id: "analisi-bilancio",
    index: "03",
    name: "Analisi di Bilancio & Business Plan",
    category: "Finance",
    description:
      "Strumenti finanziari di precisione per analizzare la salute aziendale, valutare i rischi e prevedere le performance economiche.",
    url: "https://www.ratingonline.store",
    domain: "ratingonline.store",
    Icon: TrendingUp,
    span: "",
  },
  {
    id: "business-plan",
    index: "04",
    name: "Business Plan",
    category: "Finance",
    description:
      "Piattaforma intuitiva e professionale per strutturare, sviluppare e presentare business plan con metriche impeccabili.",
    url: "https://businessplan-online.store",
    domain: "businessplan-online.store",
    Icon: Presentation,
    span: "",
  },
  {
    id: "assistenza-vocale",
    index: "05",
    name: "Assistenza Legale Vocale",
    category: "Legal Tech",
    description:
      "Consulenza legale a comando vocale e supporto rapido per risposte mirate, in tempo reale.",
    url: "https://www.rexxlegal.store",
    domain: "rexxlegal.store",
    Icon: AudioLines,
    span: "lg:col-span-2",
  },
  {
    id: "redazione-avvocato",
    index: "06",
    name: "Assistenza Redazione Attività Avvocato",
    category: "Legal Tech",
    description:
      "Co-pilota digitale per i professionisti del diritto: velocizza la redazione di atti, documenti e pareri.",
    url: "https://www.rexxlegalassistent.online",
    domain: "rexxlegalassistent.online",
    Icon: PenLine,
    span: "",
  },
  {
    id: "due-diligence",
    index: "07",
    name: "Verifica Reputazione — Due Diligence Approfondita",
    category: "Reputation",
    description:
      "Analisi reputazionale rigorosa e due diligence completa per verificare a fondo partner e aziende.",
    url: "https://www.certytrace.store",
    domain: "certytrace.store",
    Icon: ShieldCheck,
    span: "",
  },
  {
    id: "reputazione-rapida",
    index: "08",
    name: "Verifica Reputazione Rapida",
    category: "Reputation",
    description:
      "Controlli reputazionali online immediati e mirati per decisioni rapide, sicure e informate.",
    url: "https://www.reputazione.shop",
    domain: "reputazione.shop",
    Icon: Gauge,
    span: "",
  },
  {
    id: "comunicazione-avanzata",
    index: "09",
    name: "Sistema di Comunicazione Avanzato",
    category: "Communication",
    description:
      "Piattaforma di comunicazione sicura di nuova generazione: gestisce flussi vocali e digitali senza confini.",
    url: "https://www.rexxcalling.com",
    domain: "rexxcalling.com",
    Icon: RadioTower,
    span: "",
  },
];
